export default __webpack_public_path__ + "static/media/logo.78162cab.jpg";